import React, { useState } from "react";
import DateFilter from "./date";

const AdsFilter = (props) => {

  const [currentElementId, setCurrentElementId] = useState("");
  const [selectedAdsType, setSelectedAdsType] = useState("");
  const [adsTypes, setAdsTypes] = useState(["Vertical Ads", "Banner Ads", "Tv Ads"]);
  const [selectedCampaignLocation, setSelectedCampaignLocation] = useState("");
  const [allGymLocations, getAllGymLocations] = useState([
    {
      location: "Pune", 
      totalCampaigns: 5 
    },
    {
      location: "Chennai", 
      totalCampaigns: 10
    },
    {
      location: "Jaipur",
      totalCampaigns: 3
    },
    {
      location: "Surat",
      totalCampaigns: 0
    },
    {
      location: "Bangalore",
      totalCampaigns: 55
    }
  ]);


  const toggleInputFields = (id) => {
    if (currentElementId == id) {
      setCurrentElementId('')
    } else {
      setCurrentElementId(id);
    }
  };

  const selectAdsType = (adType) => {
    setSelectedAdsType(adType);
  }

  const selectLocation = (location) => {
    setSelectedCampaignLocation(location);
  }

  return(
    <div className="w-full">
      {
        props.headerView && (
          <p className="fs-16 m-b-6 font-weight-700 color-black">Ads Filter</p>
        )
      }
      <div onClick={()=>toggleInputFields('ads-type')} className={`${currentElementId == "ads-type" || selectedAdsType ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: (currentElementId == "ads-type" || selectedAdsType) ? "1px solid var(--darkBlue)" : "" }}>
        <div className="flex-item d-flex" style={{marginTop: (currentElementId == "ads-type" || selectedAdsType) ? "4px" : ""}}>
          <svg className="flex-item m-r-4" width={(currentElementId == "ads-type" || selectedAdsType) ? "12" : "20"} height={(currentElementId == "ads-type" || selectedAdsType) ? "12" : "20"} style={{ transition: "180ms" }} viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.02148 9.22877L12.0066 14.5555L12.0601 14.6518C12.3571 15.1696 12.8116 15.5727 13.3536 15.7988C13.8955 16.0249 14.4949 16.0616 15.0591 15.9031C15.6233 15.7445 16.1211 15.3997 16.4758 14.9217C16.8304 14.4437 17.0222 13.8591 17.0215 13.258C17.0232 12.7765 16.9004 12.3032 16.6658 11.8864L16.6364 11.8371L11.4501 2.61027V2.60761C10.7871 1.42053 10.102 1 9.02148 1C8.56257 0.999637 8.11137 1.12116 7.71164 1.35277C7.3119 1.58439 6.97721 1.91823 6.74002 2.32193L6.66793 2.45101C6.46719 2.83562 6.35496 3.27567 6.35496 3.74012C6.35384 4.18108 6.45664 4.61577 6.65455 5.00704L6.67311 5.04297L6.74822 5.17205L9.02148 9.22877ZM9.02148 9.22877L6.03119 14.5666M6.03119 14.5666C6.23711 14.1762 6.35496 13.7309 6.35496 13.258C6.35502 12.6641 6.16691 12.0862 5.81974 11.6114C5.47257 11.1366 4.98469 10.7905 4.42955 10.6253C3.87442 10.4601 3.28208 10.4846 2.7417 10.6953C2.20132 10.9059 1.74215 11.2912 1.43331 11.7932M6.03119 14.5666L5.98327 14.6544C5.74736 15.0641 5.4116 15.4036 5.00911 15.6393C4.60661 15.875 4.15127 15.9988 3.688 15.9985C3.33775 15.9987 2.99089 15.9279 2.66727 15.7903C2.34365 15.6526 2.04961 15.4507 1.80196 15.1962C1.55431 14.9417 1.35791 14.6395 1.22399 14.3069C1.09007 13.9743 1.02126 13.6179 1.02148 13.258C1.02148 12.7966 1.13113 12.3619 1.32928 11.9804L1.43072 11.7985L1.43331 11.7932M1.43331 11.7932L6.66793 2.45057" stroke={(currentElementId == "ads-type" || selectedAdsType) ? "var(--darkBlue)" : "#6d6d6d"} stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "ads-type" || selectedAdsType) ? "10px" : "16px", lineHeight: (currentElementId == "ads-type" || selectedAdsType) ? "10px" : "14px", color: (currentElementId == "ads-type" || selectedAdsType) ? "var(--darkBlue)" : "", transition: "180ms" }}>Ads Type</p>
        </div>
        <div className='input-field-arrow-dropdown' style={{ margin: "15px 12px 4px 0", transition: "180ms" }}>
          <svg className="flex-item" style={{ transform: currentElementId == "ads-type" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
          </svg>
        </div>
        <input id="ads-type" className={`${(currentElementId == "ads-type" || selectedAdsType) ? "active-input-field" : "inactive-input-field"} m-t-4 fs-16`} type="text" placeholder="Select" value={selectedAdsType ? selectedAdsType : ""} style={{ pointerEvents: "none", textTransform: 'capitalize' }} />
        {
          currentElementId == "ads-type" && (
            <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5"}}>
              {
                adsTypes.map((adType, index) => {
                  return (
                    <div onClick={()=>selectAdsType(adType)} className="global-input-field-arrow-dropdown-item">
                      <p className="flex-item">{adType}</p>
                    </div>
                  )
                })
              }
            </div>
          )
        }
      </div>
      <div onClick={()=>toggleInputFields('campaign-location')} className={`${currentElementId == "campaign-location" || selectedCampaignLocation ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-20`} style={{ border: (currentElementId == "campaign-location" || selectedCampaignLocation) ? "1px solid var(--darkBlue)" : "" }}>
        <div className="flex-item d-flex" style={{marginTop: (currentElementId == "campaign-location" || selectedCampaignLocation) ? "4px" : ""}}>
          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "campaign-location" || selectedCampaignLocation) ? "10px" : "16px", lineHeight: (currentElementId == "campaign-location" || selectedCampaignLocation) ? "10px" : "14px", color: (currentElementId == "campaign-location" || selectedCampaignLocation) ? "var(--darkBlue)" : "", transition: "180ms" }}>Location</p>
        </div>
        <div className='input-field-arrow-dropdown' style={{ margin: "15px 12px 4px 0", transition: "180ms" }}>
          <svg className="flex-item" style={{ transform: currentElementId == "campaign-location" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
          </svg>
        </div>
        <input id="campaign-location" className={`${(currentElementId == "campaign-location" || selectedCampaignLocation) ? "active-input-field" : "inactive-input-field"} m-t-4 fs-16`} type="text" placeholder="Select" value={selectedCampaignLocation ? selectedCampaignLocation : ""} style={{ pointerEvents: "none", textTransform: 'capitalize' }} />
        {
          currentElementId == "campaign-location" && (
            <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5"}}>
              <div onClick={e => e.stopPropagation()} className="w-full d-flex space-between" style={{padding:"8px", backgroundColor:"#f5f5f5", position:"sticky", top:0}}>
                <div className="search-container d-flex space-between" style={{width:"60%",background:"#ffffff"}}>
                  <div className="d-flex w-full">
                    <svg className="flex-item m-r-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 21L16.657 16.657M16.657 16.657C17.3999 15.9141 17.9892 15.0322 18.3912 14.0615C18.7933 13.0909 19.0002 12.0506 19.0002 11C19.0002 9.9494 18.7933 8.90908 18.3913 7.93845C17.9892 6.96782 17.3999 6.08589 16.657 5.343C15.9141 4.60011 15.0322 4.01082 14.0616 3.60877C13.0909 3.20673 12.0506 2.99979 11 2.99979C9.94942 2.99979 8.90911 3.20673 7.93848 3.60877C6.96785 4.01082 6.08591 4.60011 5.34302 5.343C3.84269 6.84333 2.99982 8.87821 2.99982 11C2.99982 13.1218 3.84269 15.1567 5.34302 16.657C6.84335 18.1573 8.87824 19.0002 11 19.0002C13.1218 19.0002 15.1567 18.1573 16.657 16.657Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <input type="text" placeholder={`Search Location`} className="flex-item search-input" style={{width:"85%"}} />
                  </div>
                </div>
                <div className="d-flex flex-item" style={{width:"30%"}}>
                <p className="flex-item fs-16 font-weight-600 color-dark-blue margin-auto">Campaigns</p>
                </div>
              </div>
              <div className="w-full" style={{padding:"0px 0 8px 8px"}}>
                {
                  allGymLocations.map((data, index) => {
                    return (
                      <div onClick={()=>selectLocation(data.location)} className="d-flex space-between global-input-field-arrow-dropdown-item">
                        <p className="flex-item" style={{width:"70%"}}>{data.location}</p>
                        <div className="d-flex flex-item" style={{width:"30%"}}>
                          <div className="d-flex flex-item p-l-8 p-r-8 p-b-8 p-t-8 bg-white margin-auto" style={{borderRadius:"6px", width:"40px"}}>
                            <p className="flex-item margin-auto" style={{lineHeight:"14px"}}>{data.totalCampaigns}</p>
                          </div>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          )
        }
      </div>
      <DateFilter/>
    </div>
  )
}

export default AdsFilter;